import type { ApiHttpClient } from '../client/http.client'
import { InventoryItem } from '../struct/store.struct'

export class StoreGateway {
  constructor(private http: ApiHttpClient) {}

  getInventory(userType: string, permanenceType: string, enveope: boolean) {
    return this.http.request(
      '/store/inventory-items',
      {
        method: 'GET',
        params: {
          usable_user_type: userType,
          permanence_type: permanenceType,
          enveope
        }
      },
      InventoryItem
    )
  }
}
